import * as api from "@/common/api";
import { DataResponse } from "@/common/class";
import { SeoulTradeStatRequest } from "../class";

/**
 * 아파트 실거래가 조회 API
 * @param payload
 * @returns
 */
export const getAptTrade = async (payload: any) => {
  //
  const res = await api.get(
    "/api/v1/apt-trade/list" + api.getQuery(payload),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

// export const getSeoulTradeStats = async () => {
//   //
//   const res = await api.get(
//     "/api/v1/apt-trade/stats/seoul-trade",
//     null,
//     new api.HeaderOption(),
//     true
//   );
//   console.log("getSeoulTradeStats res : ", res);
//   return res.data;
// };

/**
 * 서울 조건별 거래량/계약금액 변화추이
 * @param payload
 * @returns
 */
export const getSeoulTradeStats = async (payload: SeoulTradeStatRequest) => {
  //
  const res = await api.get(
    "/api/v1/apt-trade/stats/seoul-trade" + api.getQuery(payload),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 서울특별시 구별 전날 거래량 비교
 * @param payload
 * @returns
 */
export const getSeoulSggDiff = async (payload: any) => {
  //
  const res = await api.get(
    "/api/v1/apt-trade/stats/sgg-diff" + api.getQuery(payload),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

export const getDayTradeCount = async (payload: any) => {
  //
  const res = await api.get(
    "/api/v1/apt-trade/stats/day-trade-count" + api.getQuery(payload),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 관심 아파트 정보 조회
 */
export const getAptFavorite = async () => {
  const res = await api.get(
    "/api/v1/apt-favorite/list",
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 관심 아파트 추가
 */
export const addAptFavorite = async (payload: { sggCd: string; umdCd: string; aptNm: string }) => {
  const res = await api.post("/api/v1/apt-favorite", payload);
  return res.data;
};

/**
 * 관심 아파트 삭제
 */
export const deleteAptFavorite = async (id: number) => {
  const res = await api.remove("/api/v1/apt-favorite/" + id);
  return res.data;
};

/**
 * 구별 평균 거래금액 랭킹
 */
export const getSggAvgAmount = async (payload?: { months?: number }) => {
  const res = await api.get(
    "/api/v1/apt-trade/stats/sgg-avg-amount" + api.getQuery(payload || {}),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};

/**
 * 최근 N건 실거래 조회
 */
export const getRecentTrades = async (payload?: { size?: number }) => {
  const res = await api.get(
    "/api/v1/apt-trade/recent" + api.getQuery(payload || {}),
    null,
    new api.HeaderOption(),
    true
  );
  return res.data;
};
